import {
	ApiResponse,
	EmailPayload,
	UserPasswordReset,
} from "@vita-learning/types";

import { resHttpClient as httpClient } from "../../config";

export const sendEmailVerificationToken = async (
	email: EmailPayload
): Promise<void> => {
	const resp = await httpClient.put<ApiResponse<void>>(
		"/users/email/token",
		email
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const sendResetPasswordToken = async (
	email: EmailPayload
): Promise<void> => {
	const resp = await httpClient.put<ApiResponse<void>>(
		"/users/password/token",
		email
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};

export const resetPassword = async (
	token: string,
	password: UserPasswordReset
): Promise<void> => {
	const resp = await httpClient.patch<ApiResponse<void>>(
		`/users/password?token=${token}`,
		password
	);

	if (resp.debug) console[resp.debug.level](resp.debug);

	if (!resp.success) throw resp.error;

	return resp.data;
};
